import { render, staticRenderFns } from "./CardMealActionViewMeal.vue?vue&type=template&id=4d908848&scoped=true"
import script from "./CardMealActionViewMeal.vue?vue&type=script&lang=js"
export * from "./CardMealActionViewMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d908848",
  null
  
)

export default component.exports